var rules = function (blockClass) {
  return [".".concat(blockClass, " { background: currentColor }"), 'noscript { display: none !important; }'];
};
export { rules as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@sentry/replay/esm/node_modules/rrweb/es/rrweb/packages/rrweb/src/replay/styles/inject-style.js
// module id = null
// module chunks = 